/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Dispute,
    DisputeFromJSON,
    DisputeFromJSONTyped,
    DisputeToJSON,
} from './Dispute';
import {
    OrderV2,
    OrderV2FromJSON,
    OrderV2FromJSONTyped,
    OrderV2ToJSON,
} from './OrderV2';
import {
    PaymentAmount,
    PaymentAmountFromJSON,
    PaymentAmountFromJSONTyped,
    PaymentAmountToJSON,
} from './PaymentAmount';
import {
    PaymentAmountFee,
    PaymentAmountFeeFromJSON,
    PaymentAmountFeeFromJSONTyped,
    PaymentAmountFeeToJSON,
} from './PaymentAmountFee';
import {
    PaymentAmountReceived,
    PaymentAmountReceivedFromJSON,
    PaymentAmountReceivedFromJSONTyped,
    PaymentAmountReceivedToJSON,
} from './PaymentAmountReceived';
import {
    PaymentAmountTotal,
    PaymentAmountTotalFromJSON,
    PaymentAmountTotalFromJSONTyped,
    PaymentAmountTotalToJSON,
} from './PaymentAmountTotal';
import {
    PaymentDeclineCode,
    PaymentDeclineCodeFromJSON,
    PaymentDeclineCodeFromJSONTyped,
    PaymentDeclineCodeToJSON,
} from './PaymentDeclineCode';
import {
    PaymentMethod,
    PaymentMethodFromJSON,
    PaymentMethodFromJSONTyped,
    PaymentMethodToJSON,
} from './PaymentMethod';
import {
    PaymentObjectType,
    PaymentObjectTypeFromJSON,
    PaymentObjectTypeFromJSONTyped,
    PaymentObjectTypeToJSON,
} from './PaymentObjectType';
import {
    PaymentSource,
    PaymentSourceFromJSON,
    PaymentSourceFromJSONTyped,
    PaymentSourceToJSON,
} from './PaymentSource';
import {
    PayoutProvider,
    PayoutProviderFromJSON,
    PayoutProviderFromJSONTyped,
    PayoutProviderToJSON,
} from './PayoutProvider';
import {
    User,
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface PaymentResultV2
 */
export interface PaymentResultV2 {
    /**
     * 
     * @type {string}
     * @memberof PaymentResultV2
     */
    id: string;
    /**
     * 
     * @type {PaymentObjectType}
     * @memberof PaymentResultV2
     */
    object: PaymentObjectType;
    /**
     * 
     * @type {string}
     * @memberof PaymentResultV2
     */
    program_id: string;
    /**
     * 
     * @type {PaymentDeclineCode}
     * @memberof PaymentResultV2
     */
    error_code?: PaymentDeclineCode;
    /**
     * 
     * @type {PaymentAmount}
     * @memberof PaymentResultV2
     */
    amount: PaymentAmount;
    /**
     * 
     * @type {PaymentAmountFee}
     * @memberof PaymentResultV2
     */
    amount_fee: PaymentAmountFee;
    /**
     * 
     * @type {PaymentAmountTotal}
     * @memberof PaymentResultV2
     */
    amount_total: PaymentAmountTotal;
    /**
     * 
     * @type {PaymentAmountReceived}
     * @memberof PaymentResultV2
     */
    amount_received: PaymentAmountReceived;
    /**
     * 
     * @type {any}
     * @memberof PaymentResultV2
     */
    metadata: any;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof PaymentResultV2
     */
    checkout_method: PaymentMethod;
    /**
     * 
     * @type {Dispute}
     * @memberof PaymentResultV2
     */
    dispute?: Dispute;
    /**
     * 
     * @type {PaymentSource}
     * @memberof PaymentResultV2
     */
    payment_source?: PaymentSource;
    /**
     * 
     * @type {PayoutProvider}
     * @memberof PaymentResultV2
     */
    payment_provider?: PayoutProvider;
    /**
     * 
     * @type {string}
     * @memberof PaymentResultV2
     */
    payment_provider_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentResultV2
     */
    timezone: string;
    /**
     * 
     * @type {Date}
     * @memberof PaymentResultV2
     */
    created: Date;
    /**
     * 
     * @type {User}
     * @memberof PaymentResultV2
     */
    created_by: User;
    /**
     * 
     * @type {Date}
     * @memberof PaymentResultV2
     */
    updated?: Date;
    /**
     * 
     * @type {User}
     * @memberof PaymentResultV2
     */
    updated_by?: User;
    /**
     * 
     * @type {OrderV2}
     * @memberof PaymentResultV2
     */
    order: OrderV2;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentResultV2
     */
    has_next_action: boolean;
    /**
     * 
     * @type {string}
     * @memberof PaymentResultV2
     */
    next_action_url?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentResultV2
     */
    client_secret?: string;
}

export function PaymentResultV2FromJSON(json: any): PaymentResultV2 {
    return PaymentResultV2FromJSONTyped(json, false);
}

export function PaymentResultV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentResultV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'object': PaymentObjectTypeFromJSON(json['object']),
        'program_id': json['program_id'],
        'error_code': !exists(json, 'error_code') ? undefined : PaymentDeclineCodeFromJSON(json['error_code']),
        'amount': PaymentAmountFromJSON(json['amount']),
        'amount_fee': PaymentAmountFeeFromJSON(json['amount_fee']),
        'amount_total': PaymentAmountTotalFromJSON(json['amount_total']),
        'amount_received': PaymentAmountReceivedFromJSON(json['amount_received']),
        'metadata': json['metadata'],
        'checkout_method': PaymentMethodFromJSON(json['checkout_method']),
        'dispute': !exists(json, 'dispute') ? undefined : DisputeFromJSON(json['dispute']),
        'payment_source': !exists(json, 'payment_source') ? undefined : PaymentSourceFromJSON(json['payment_source']),
        'payment_provider': !exists(json, 'payment_provider') ? undefined : PayoutProviderFromJSON(json['payment_provider']),
        'payment_provider_id': !exists(json, 'payment_provider_id') ? undefined : json['payment_provider_id'],
        'timezone': json['timezone'],
        'created': (new Date(json['created'])),
        'created_by': UserFromJSON(json['created_by']),
        'updated': !exists(json, 'updated') ? undefined : (new Date(json['updated'])),
        'updated_by': !exists(json, 'updated_by') ? undefined : UserFromJSON(json['updated_by']),
        'order': OrderV2FromJSON(json['order']),
        'has_next_action': json['has_next_action'],
        'next_action_url': !exists(json, 'next_action_url') ? undefined : json['next_action_url'],
        'client_secret': !exists(json, 'client_secret') ? undefined : json['client_secret'],
    };
}

export function PaymentResultV2ToJSON(value?: PaymentResultV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'object': PaymentObjectTypeToJSON(value.object),
        'program_id': value.program_id,
        'error_code': PaymentDeclineCodeToJSON(value.error_code),
        'amount': PaymentAmountToJSON(value.amount),
        'amount_fee': PaymentAmountFeeToJSON(value.amount_fee),
        'amount_total': PaymentAmountTotalToJSON(value.amount_total),
        'amount_received': PaymentAmountReceivedToJSON(value.amount_received),
        'metadata': value.metadata,
        'checkout_method': PaymentMethodToJSON(value.checkout_method),
        'dispute': DisputeToJSON(value.dispute),
        'payment_source': PaymentSourceToJSON(value.payment_source),
        'payment_provider': PayoutProviderToJSON(value.payment_provider),
        'payment_provider_id': value.payment_provider_id,
        'timezone': value.timezone,
        'created': (value.created.toISOString()),
        'created_by': UserToJSON(value.created_by),
        'updated': value.updated === undefined ? undefined : (value.updated.toISOString()),
        'updated_by': UserToJSON(value.updated_by),
        'order': OrderV2ToJSON(value.order),
        'has_next_action': value.has_next_action,
        'next_action_url': value.next_action_url,
        'client_secret': value.client_secret,
    };
}

